import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import TomSelect from 'tom-select';
import * as styles from './styles.module.scss';
import { SelectProps } from './types';

const Select = ({
  className,
  options,
  name,
  size,
  error,
  placeholder,
  value = '',
  onChange,
  hideClear,
  ...rest
}: SelectProps) => {
  const selectRef = useRef<HTMLSelectElement>(null);

  useEffect(() => {
    if (!selectRef.current) return;

    const ts = new TomSelect(selectRef.current, {
      plugins: !hideClear ? ['remove_button'] : [],
      controlInput: '<input>',
      dropdownContentClass: classNames(
        'dropdown-menu show w-100',
        styles.dropdown,
      ),
      optionClass: 'dropdown-item',
      valueField: 'value',
      wrapperClass: 'form-select ts-wrapper',
      labelField: 'label',
      searchField: ['label'],
      maxItems: 1,
      options,
      items: value !== undefined && value !== null ? [value.toString()] : [],
      placeholder,
      onChange: (val: string) => {
        onChange && onChange(val);
      },

    });

    return () => {
      ts.destroy();
    };
  }, [options, hideClear]);

  useEffect(() => {
    const el = selectRef.current;
    if (el && (el as any).tomselect) {
      const ts = (el as any).tomselect as TomSelect;
      ts.clear(true);
      ts.addOptions(options);
      if (value !== undefined && value !== null && value !== '') {
        ts.setValue(value.toString(), true);
      }
    }
  }, [value, options]);

  useEffect(() => {
    const el = selectRef.current;
    if (el && (el as any).tomselect) {
      const ts = (el as any).tomselect as TomSelect;

      ts.wrapper.classList.remove('is-invalid', 'border', 'border-danger');
      if (error) {
        ts.wrapper.classList.add('is-invalid', 'border', 'border-danger');
      }
    }
  }, [error]);

  return (
    <div>
      <select
        className={`form-select ${className || ''}`}
        ref={selectRef}
        name={name}
        data-size={size}
        style={{ width: '100%' }}
        {...rest}
      ></select>
    </div>
  );
};

export default Select;
